import Const from 'constants';
import Action from 'actions';
import {StackItem} from 'components/organisms/player-combination-stacking/stack-item';

let PlayerCombinationStacking = {
    usePlayerCombinationStacking(use) {
        return {
            type: Const.PLAYER_COMBINATION_STACKING_SET_IS_USED,
            use,
        };
    },

    setPlayerCombinationStackingSettingsFromStorage(data) {
        return (dispatch) => {
            dispatch({
                type: Const.PLAYER_COMBINATION_STACKING_SET_DATA_FROM_STORAGE,
                data,
            });
        };
    },

    addItemToPlayerCombinationStacking(stackItem) {
        return (dispatch) => {
            dispatch({
                type: Const.PLAYER_COMBINATION_STACKING_ADD_ITEM,
                stackItem,
            });

            dispatch(this.savePlayerCombinationStackingToStorage());
        };
    },

    removeItemOfPlayerCombinationStacking(itemId) {
        return (dispatch) => {
            dispatch({
                type: Const.PLAYER_COMBINATION_STACKING_REMOVE_ITEM,
                itemId,
            });

            dispatch(this.savePlayerCombinationStackingToStorage());
        };
    },

    savePlayerCombinationStackingToStorage() {
        return (dispatch) => {
            dispatch(
                this.saveDataToStorage('playerCombinationStacking', function (state) {
                    const {playerCombinationStacking} = state;

                    return playerCombinationStacking.all();
                }),
            );
        };
    },
};

export default Object.assign(Action, PlayerCombinationStacking);
